import type { ClearedAs } from 'bundles/os/home/types';

export type NextActionSubject = {
  subjectId: number | string;
  subjectType: string;
};

export type OpenAssistantOptions = {
  brief?: NextActionSubject;
  prompt?: string;
};

export const OPEN_ASSISTANT_EVENT = 'ai-assistant:open';

export const openAssistant = (opts: OpenAssistantOptions = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_ASSISTANT_EVENT, { detail: opts }));
};

export const CLOSE_ASSISTANT_EVENT = 'ai-assistant:close';

export const TOGGLE_ASSISTANT_EVENT = 'ai-assistant:toggle';

export const toggleAssistant = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TOGGLE_ASSISTANT_EVENT));
};

export type NextActionChange = NextActionSubject & {
  as: ClearedAs | null;
  source: 'assistant' | 'home';
};

export const NEXT_ACTION_CHANGED_EVENT = 'ai-assistant:next-action-changed';

export const announceNextAction = (change: NextActionChange) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(NEXT_ACTION_CHANGED_EVENT, { detail: change }));
};

export type NextBriefOffer = {
  done: string;
  next: { brief: NextActionSubject; name: string; prompt: string } | null;
};

export const NEXT_BRIEF_OFFERED_EVENT = 'ai-assistant:next-brief-offered';

export const offerNextBrief = (offer: NextBriefOffer) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(NEXT_BRIEF_OFFERED_EVENT, { detail: offer }));
};
